import React from "react";
import { colors } from "@/assets/themes";
import { Body14, Body16 } from "@/components/text";
import Icon from "@/components/icon";
import List from "@/components/list";
import Shape from "@/components/shape";
import { SHAPE } from "@/components/styles/variants/shape";
import polyglot from "@/utils/polyglot";

const CustomAskItem = React.memo(
  ({ href, onClick, divider }) => (
    <List.Item
      chevron
      divider={divider}
      href={href}
      LeftComponent={() => (
        <Shape.Large
          backgroundColor={colors.mutedLight}
          color={colors.onColor}
          shape={SHAPE.SHAPE.ROUND}
        >
          <Icon.Large name="edit" />
        </Shape.Large>
      )}
      onClick={onClick}
      withGutters
    >
      <Body14 color={colors.muted}>
        {polyglot.t("categories_modal.cant_find_category_question")}
      </Body14>
      <Body16 strong>{polyglot.t("categories_modal.create_custom_job")}</Body16>
    </List.Item>
  ),
  (prevProps, nextProps) => prevProps.isLoading === nextProps.isLoading
);
export default CustomAskItem;
